'use strict';

module.exports = {
    pools: /*@ngInject*/  ["SimResource", "ProjectService", function (SimResource, ProjectService) {
        return SimResource.pools().query({'projectId': ProjectService.getSelectedProjectId()}).$promise;
    }],
    trains: /*@ngInject*/  ["TrainService", "ProjectService", function (TrainService, ProjectService) {
        return TrainService.getTrains().query({'projectId': ProjectService.getSelectedProjectId()}).$promise;
    }]
};